module.exports = __webpack_public_path__ + "img/img_slide_9.c38fbcde.webp";